import PersonSelect from './PersonSelect';

export default PersonSelect;
